import React, {Component} from "react";
import {
  Modal,
  FormGroup,
  FormControl,
  Button,
  ControlLabel,
  InputGroup
} from "react-bootstrap";
import PaymentMethod from "../../home/components/payment-method";
import './notification-message.css';

const INT_RE = /^\d{1,2}$/;

class NotificationMessage extends Component {
  state = {
    'deposit-1': '',
    'deposit-2': ''
  }

  onInputChange = (key, value) => {
    const currentValue = this.state[key];
    const isValid = INT_RE.test(value) || value === '';
    this.setState({[key]: isValid ? value : currentValue});
  }

  handleVerifyAccount = (event) => {
    event.preventDefault();
    this.props.handleVerifyAccount(this.state);
  }

  render() {
    const paymentMethodOptions = {
      showActions: false,
      showSelect: true,
      className: "col-md-6"
    };

      return (
          <Modal
              show={true}
              onHide={this.props.closeAchVerification}
              bsSize="large"
          >
              <form
                  onSubmit={this.handleVerifyAccount}
                  className="clearfix bank-account-form"
              >
                  <Modal.Header closeButton>
                      <Modal.Title className="text-primary">
                          Bank Account Verification
                      </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <h5>Bank account verification needed!</h5>
                      <p>
                          You have linked your bank account with Finpay as payment method.
                          For your security you will need to verify account ownership.
                      </p>
                      <p>
                          If you received the two micro-deposits on your bank account (both
                          are less than $1 each), please contact support at (855-4-FINPAY)
                      </p>

                  </Modal.Body>
                  <Modal.Footer className="col-md-12">
                      <Button onClick={this.props.closeAchVerification}>
                          Close
                      </Button>
                  </Modal.Footer>
              </form>
          </Modal>
      );

    // return (
    //   <Modal
    //     show={true}
    //     onHide={this.props.closeAchVerification}
    //     bsSize="large"
    //   >
    //     <form
    //       onSubmit={this.handleVerifyAccount}
    //       className="clearfix bank-account-form"
    //     >
    //       <Modal.Header closeButton>
    //         <Modal.Title className="text-primary">
    //           Bank Account Verification
    //         </Modal.Title>
    //       </Modal.Header>
    //       <Modal.Body>
    //         <h5>Bank account verification needed!</h5>
    //         <p>
    //           You have linked your bank account with Finpay as payment method.
    //           For your security you will need to verify account ownership. We
    //           recommend taking the time to verify your bank account to avoid any
    //           complications.
    //         </p>
    //         <p>
    //           If you received the two micro-deposits on your bank account (both
    //           are less than $1 each), please enter the deposits amounts bellow:
    //         </p>
    //
    //         <div className="ach-select-payment">
    //           <b>Bank Account:</b>
    //           <br />
    //           <br />
    //
    //           {this.props.bank_accounts.map(bank => (
    //             <PaymentMethod
    //               key={bank.sourceId}
    //               paymentMethod={bank}
    //               viewState={paymentMethodOptions}
    //               selectedPaymentMethod={this.props.selectedBankAccount}
    //               setPaymentMethod={this.props.selectBankAccount}
    //               currentPlan={this.props.currentPlan}
    //             />
    //           ))}
    //         </div>
    //
    //         <div className="col-md-2">
    //           <FormGroup className="verification-input">
    //             <ControlLabel>Micro-deposit 1</ControlLabel>
    //             <InputGroup>
    //               <InputGroup.Addon>$0.</InputGroup.Addon>
    //               <FormControl
    //                 type="text"
    //                 name="deposit-1"
    //                 required
    //                 value={this.state['deposit-1']}
    //                 onChange={({target: {value}}) => this.onInputChange('deposit-1', value)}
    //               />
    //             </InputGroup>
    //
    //           </FormGroup>
    //           <FormGroup  className="verification-input">
    //             <ControlLabel>Micro-deposit 2</ControlLabel>
    //             <InputGroup>
    //               <InputGroup.Addon>$0.</InputGroup.Addon>
    //               <FormControl
    //                 type="text"
    //                 name="deposit-2"
    //                 required
    //                 value={this.state['deposit-2']}
    //                 onChange={({target: {value}}) => this.onInputChange('deposit-2', value)}
    //               />
    //             </InputGroup>
    //           </FormGroup>
    //         </div>
    //       </Modal.Body>
    //       <Modal.Footer className="col-md-12">
    //         <Button onClick={this.props.closeAchVerification}>
    //           Verify Later
    //         </Button>
    //         <Button type="submit" className="btn btn-warning">
    //           Verify
    //         </Button>
    //       </Modal.Footer>
    //     </form>
    //   </Modal>
  // );
  }

}

export default NotificationMessage;



// WEBPACK FOOTER //
// ./src/shared/components/notification-message.js